import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useAppContext } from 'providers/AppProvider';
import { Link } from 'react-router-dom';
import logoDark from '../../assets/img/logo-dark.svg';
import logoLight from '../../assets/img/logo-light.svg';

const Logo = ({ at, width, className, textClass, isLink = true, ...rest }) => {
  const { config } = useAppContext();
  const { isDark } = config;
  return (
    <>
      {isLink ? (
        <Link
          to="/dashboards/tickets"
          className={classNames(
            'text-decoration-none',
            { 'navbar-brand text-left': at === 'navbar-vertical' },
            { 'navbar-brand text-left': at === 'navbar-top' }
          )}
          {...rest}
        >
          <div
            className={classNames(
              'd-flex',
              {
                'align-items-center py-3': at === 'navbar-vertical',
                'align-items-center': at === 'navbar-top',
                'flex-center fw-bolder fs-5 mb-4': at === 'auth'
              },
              className
            )}
          >
            {' '}
            {isDark ? (
              <img
                className="me-2"
                src={logoDark}
                alt="MSP Desk Logo"
                width={width}
              />
            ) : (
              <img
                className="me-2"
                src={logoLight}
                alt="MSP Desk Logo"
                width={width}
              />
            )}
          </div>
        </Link>
      ) : (
        <Link
          to="#"
          className={classNames(
            'text-decoration-none',
            { 'navbar-brand text-left': at === 'navbar-vertical' },
            { 'navbar-brand text-left': at === 'navbar-top' }
          )}
          {...rest}
        >
          <div
            className={classNames(
              'd-flex',
              {
                'align-items-center py-3': at === 'navbar-vertical',
                'align-items-center': at === 'navbar-top',
                'flex-center fw-bolder fs-5 mb-4': at === 'auth'
              },
              className
            )}
          >
            {' '}
            {isDark ? (
              <img
                className="me-2"
                src={logoDark}
                alt="MSP Desk Logo"
                width={width}
              />
            ) : (
              <img
                className="me-2"
                src={logoLight}
                alt="MSP Desk Logo"
                width={width}
              />
            )}
          </div>
        </Link>
      )}
    </>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
